import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=5673b842&scoped=true&"
import script from "./DoctorInfo.vue?vue&type=script&lang=js&"
export * from "./DoctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=5673b842&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673b842",
  null
  
)

export default component.exports